import http from "@/http/aisea/axios";

const resource = "/user/public";

export default {

  get(id) {
    return http.get(`${resource}/${id}`);
  },

};
